import { useEffect } from "react";
import { useUserData } from "store/slices/authSlice";
import { setSentryUser } from "utils/sentry";

const SentryUserContext = () => {
  const userData = useUserData();
  const accountData = userData?.data?.accountData;

  useEffect(() => {
    setSentryUser({
      id: accountData?.id,
      email: accountData?.email,
      username:
        [accountData?.first_name, accountData?.last_name]
          .filter(Boolean)
          .join(" ") || undefined,
      accountId: accountData?.accountid,
      clusterId: accountData?.clusterid,
    });
  }, [accountData]);

  return null;
};

export default SentryUserContext;
